<!--
  @Description: 数据图片-收藏
  @Author: wang.y 
  @Date: 2022-02-23 
-->
<template>
  <div>
    <div class="commonlist">
      <div class="img-item" v-for="(item, index) in list" :key="item.id">
        <div class="img2" @click="handReport(item)">
          <img :src="item.file_path | logo_show('/report_image')" class="pic" />
        </div>
        <div class="info">
          <div class="title over-p2" @click="handReport(item)">{{item.file_name}}</div>
          <div class="source">
            <div>所属报告：</div>
              <!-- @click="$parent.goDetail(1, item.uid)" -->
            <div class="report">{{item.title}}</div>
          </div>
          <div class="dec">
            <div class="lt"></div>
            <div class="collect_share">
              {{item.create_time}}
              <i class="iconfont collec-icon" title="取消收藏" @click="handleCancel('9', item.id, cancelCollectCb, index)">&#xe66f;</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Spin v-if="loading">
      <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
      <div>Loading</div>
    </Spin>
    <div class="more-btn" v-if="more && !loading">
      <div @click="handleMore('9')">加载更多</div>
    </div>
    <default-list v-if="!list.length && !loading">
      <template slot="p">
        <p>您目前没有收藏任何数据图表，不如去随便逛逛<br />看看有什么内容值得收藏起来，反复品读</p>
      </template>
    </default-list>
    <ReportModal :isReportModal="is_reportModal" :detail="detail" :relation="relation" @closeModal="closeModal"></ReportModal>
  </div>
</template>
<script>
import ReportModal from '@/components/vcbeat/ReportModal'
import { getReportChartList } from '@/service.js'
import DefaultList from './DefaultList'
import { collect_list } from 'js/collect_list'
export default {
  mixins: [collect_list],
  components: {
    DefaultList, ReportModal
  },
  created() {
    this.userFavorite('9')
  },
  mounted() { },
  data() {
    return {
      is_reportModal: false,
      detail: {},
      relation: [],
    }
  },
  computed: {},
  methods: {
    //图表弹窗
    async handReport(item) {
      this.detail = {
        filePath: item.file_path,
        fileName: item.file_name,
        reportTitle: item.title,
        id: item.id - 0,
        reportUid: item.uid,
      }
      let res = await getReportChartList( {
        file_id: item.id - 0,
        app_layer_tag: [],
        name: '',
        page: 1,
        size: 3
      }, (error) => {
        this.$message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'relation', res.data.records)
        this.is_reportModal = true
      } else {
        this.$message.error(res.msg)
      }
    },
    closeModal() {
      this.is_reportModal = false
    }
  }
}
</script>
<style lang="stylus" scoped></style>